import React, { Fragment } from 'react';
import LoginForm from '../components/LoginForm'


export default class Login extends React.Component {

  render(){
    return (
      <Fragment>
        <LoginForm />
      </Fragment>
    );
  }

}